module.exports = __webpack_public_path__ + "static/media/kimngan.41413f7a.png";